import React from 'react';
import Grid from '@material-ui/core/Grid';
import strings from 'strings';
import InfoLabel from 'UI/components/molecules/InfoLabel';

import { EMPTY_VALUE, formatCallDateTime } from '../interviewCallReadOnly.utils';

const COPIES = strings.sendoutsV2.drawers.sendoutInterviewDetails.calls;

export const PreparationCallReadOnly = ({ values }) => {
  const fields = [
    {
      title: COPIES.hiringAuthorityCall,
      description: formatCallDateTime(values?.hiringauthorityInterviewDate)
    },
    {
      title: COPIES.candidateCall,
      description: formatCallDateTime(values?.candidateInterviewDate)
    },
    {
      title: COPIES.hiringAuthorityInsights,
      description: values?.hiringAuthorityInsights || EMPTY_VALUE
    },
    {
      title: COPIES.candidateInsights,
      description: values?.candidateInsights || EMPTY_VALUE
    }
  ];

  return (
    <Grid container spacing={2}>
      {fields.map(({ description, title }) => (
        <Grid item key={title} xs={6}>
          <InfoLabel title={title} description={description} mode="text" variant="body1" />
        </Grid>
      ))}
    </Grid>
  );
};
